import distillerService from './distiller.service';
import emojiService from './emoji.service';
import formatterService from './formatter.service';

export default angular
  .module('st.Core.Text', [])
  .service('distillerService', distillerService)
  .service('emojiService', emojiService)
  .service('formatterService', formatterService);
